module.exports = __webpack_public_path__ + "media/images/hero/glyph-b4-0884c15ba88d6d77e0697ac6ac141088.svg";